export class LabelResponseModel {
  objectId: string = '';
  contentHtml: string = '';
  checked: boolean = false;
}
